import { Injectable } from '@angular/core';

import { DealerConsent } from '../../../../model/customer-information.model';
import { RetailCrmPrivacyConsent } from '../../model/responses/account-details.model';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmDealerConsentViewModelMapper {
  mapDealerConsent(privacyConsent: RetailCrmPrivacyConsent | undefined): DealerConsent | undefined {
    // Checking if privacyConsent is defined does not work, as the field "privacyConsent" is always sent by Retail CRM, however it might be empty.
    // Instead, it is checked if the consentId is set. If so, the whole object is valied and filled.
    const privacyConsentId = privacyConsent?.consentId;
    if (!privacyConsentId) {
      return;
    }

    const consentId = privacyConsent.consentId;
    const consentDate = privacyConsent.consentDate;
    const email = privacyConsent.contactChannels?.email;
    const inCar = privacyConsent.contactChannels?.inCar;
    const letter = privacyConsent.contactChannels?.letter;
    const phoneMessenger = privacyConsent.contactChannels?.phoneMessenger;
    const customerProfile = privacyConsent.customerProfile;
    const dataProcessing = privacyConsent.dataProcessing;
    if (
      consentId === undefined ||
      consentDate === undefined ||
      email === undefined ||
      inCar === undefined ||
      letter === undefined ||
      phoneMessenger === undefined ||
      customerProfile === undefined ||
      dataProcessing === undefined
    ) {
      throw new Error('#CDFTF0106 Privacy consent field is undefined which should not be undefined');
    }

    return {
      consentId,
      consentDate,
      consent: {
        email,
        inCar,
        letter,
        phoneMessenger,
        customerProfile,
        dataProcessing,
      },
    };
  }
}
